import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OldIconComponent } from './OldIcon.component';

export const OldIconModuleExports = [OldIconComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...OldIconModuleExports],
    exports: [...OldIconModuleExports],
    providers: []
})
export class OldIconModule {}
